
//#region src/isRepositoryName.ts
/**
* Determines if an input is a valid Prismic repository name.
*
* @param input - Input to test.
*
* @returns `true` if `input` is a valid Prismic repository name, `false`
*   otherwise.
*/
const isRepositoryName = (input) => {
	return /^[a-zA-Z0-9][-a-zA-Z0-9]{2,}[a-zA-Z0-9]$/.test(input);
};

//#endregion
exports.isRepositoryName = isRepositoryName;
//# sourceMappingURL=isRepositoryName.cjs.map